import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import ReactPaginate from 'react-paginate';
import DialogExample from "./components/DialogExample/DialogExample";
import AddCategoryModal from "./components/AddCategoryModal";
import UpdateCategoryModal from "./components/UpdateCategoryModal";
import { isMobile } from "react-device-detect";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { BiSearch } from "react-icons/bi";
import { MdAdd } from "react-icons/md";
// import { BiDetail } from "react-icons/bi";
import moment from "moment";
import { MdOutlineEdit } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";
import { BiArrowBack } from "react-icons/bi";

// import { GrAddCircle } from "react-icons/gr";
import './style.css'

class Category extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldsQuote: {},
      errorsQuote: {},
      fieldsUserUpdate: {},
      fieldsUserPasswordUpdate: {},
      errorsUpdateQuote: {},
      errorsUpdatePassword: {},
      viewRowData: {},
      addQuoteModal: false,
      moreDetailsCreateModal: false,
      updateCategoryModal: false,
      loginToThisAccountModal: false,
      addCategoryModal: false,
      creditpasswordOpenModal: false,
      followUpModal: false,
      fieldsUser: {},
      errorsUpdate: {},

      balance: '',
      offset: 0,
      size: 10,
      pageNo: 1,
      keyWord: '',
    }
  }
  componentDidMount() {
    let reqData = {
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getCategoryList(reqData));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.users.addUserSuccess) {
      return {
        ...nextProps,
        fieldsUserUpdate: {},
        fieldsUserPasswordUpdate: {},
        errorsUpdateQuote: {},
        fieldsQuote: {},
        errorsQuote: {},
        errorsUpdatePassword: {},
        updateCategoryModal: false,
        creditpasswordOpenModal: false,
        addCategoryModal: false,
        addQuoteModal: false,
        followUpModal: false,
        fieldsUser: {},
        errorsUpdateQuoteAdd: {},
        errorsUpdate: {},
        AddBalanceModal: false,
        DeductBalanceModal: false,
        balance: '',
        idParam: '',
        fieldsUserdeduct: ''

      }
    } else {
      return {
        ...nextProps,

      }
    }
  }

  handlePageClick = (data) => {
    console.log("data  ", data);
    let offset = Math.ceil(data.selected * this.state.size);
    this.setState({ offset: offset, page: data.selected });
    let datatemp = {
      "keyWord": this.state.keyWord,
      "pageNo": data.selected + 1,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getCategoryList(datatemp));
    // this.props.dispatch(userActions.getLeadList(datatemp));
  }

  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getCategoryList(data));
  }

  updateCategoryStatus = (data) => {
    let datatemp = {
      "id": data.id,
    }
    let paginationdata = {
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    confirmAlert({


      title: 'Confirm to change status Category?',
      message: `Are you sure to change status of ${data.name} Category?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(userActions.updateCategoryStatus(datatemp, paginationdata))
        },
        {
          label: 'No'
        }
      ]
    });
  }

  deleteCategory = (data) => {
    let datatemp = {
      "id": data.id,
    }
    let paginationData = {
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }

    confirmAlert({

      title: 'Confirm to Delete?',
      message: `Are you sure to delete ${data.name} Category?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(userActions.deleteCategory(datatemp, paginationData))
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleUpdateCategoryModal = (data) => {
    this.setState({ updateCategoryModal: true, fieldsUserUpdate: data });
  }

  handleUpdateCategoryModalClose = () => {
    this.setState({ updateCategoryModal: false });
  }

  inputAddUserChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsQuote = this.state.fieldsQuote;
    let errorsQuote = this.state.errorsQuote;
    fieldsQuote[name] = value;
    console.log(name, value);
    errorsQuote[name] = "";
    this.setState({ fieldsQuote, errorsQuote });
  }

  inputChangeUpdateUser = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsUserUpdate = this.state.fieldsUserUpdate;
    let errorsUpdateQuote = this.state.errorsUpdateQuote;
    fieldsUserUpdate[name] = value;
    errorsUpdateQuote[name] = "";
    this.setState({ fieldsUserUpdate, errorsUpdateQuote });
  }

  createCategorySubmit = () => {
    if (this.handleValidationAddUser()) {
      let reqData = {
        "name": this.state.fieldsQuote.name
      }
      this.props.dispatch(userActions.createCategory(reqData));
    }
  }

  handleValidationAddUser = () => {
    let fieldsQuote = this.state.fieldsQuote;
    let errorsQuote = {};
    let formIsValid = true;

    //name
    if (!fieldsQuote["name"] || fieldsQuote["name"] === "") {
      formIsValid = false;
      errorsQuote["name"] = "Name cannot be empty";
    }

    console.log('errorsUpdateQuoteerrorsUpdateQuoteerrorsUpdateQuote', errorsQuote);
    this.setState({ errorsQuote: errorsQuote });
    return formIsValid;
  }

  updateCategory = () => {
    if (this.handleValidationUpdateUser()) {
      let reqData = {
        "id": this.state.fieldsUserUpdate.id,
        "name": this.state.fieldsUserUpdate.name
      }
      let paginationData = {
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size
      }

      this.props.dispatch(userActions.updateCategory(reqData, paginationData));
    }

  }

  handleValidationUpdateUser = () => {
    let fieldsUserUpdate = this.state.fieldsUserUpdate;
    let errorsUpdateQuote = {};
    let formIsValid = true;

    //name
    if (!fieldsUserUpdate["name"] || fieldsUserUpdate["name"] === "") {
      formIsValid = false;
      errorsUpdateQuote["name"] = "Name cannot be empty";
    }

    console.log("errorsUpdateQuoteerrorsUpdateQuoteerrorsUpdateQuote", errorsUpdateQuote);
    this.setState({ errorsUpdateQuote: errorsUpdateQuote });
    return formIsValid;
  }


  handleAddCategoryModal = () => {
    this.setState({ addCategoryModal: true, })
  }

  handleAddCategoryModalClose = () => {
    this.setState({ addCategoryModal: false })
  }

  handleGoBack = () => {
    this.props.history.goBack();
  };


  render() {

    let { users } = this.props;
    let {
      //  filesDetails,
        leadItems, leadTotal, loading } = users;

    return (

      <>
        <div>
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>

        <div className="flex flex-col flex-1 overflow-hidden overflow-y-auto">
          <main className="relative flex-1 ">
            <div className="p-3 2xl:p-10 sm:p-5">
              <div className="mx-auto max-w-screen-3xl ">
                {/* Transaction Section */}
                <section className="p-6 space-y-6 bg-white border rounded-md">

                  <div className="flex flex-wrap items-center justify-between w-full ">
                    <div className="flex space-x-6">
                      <div onClick={this.handleGoBack} className='p-1 text-gray-600 border border-gray-400 rounded-full cursor-pointer hover:bg-blue-400 hover:border-blue-400 hover:text-white'><BiArrowBack className='w-6 h-6' /></div>
                      <h3 className="font-medium text-xl text-[#3D405B] whitespace-nowrap">Category List</h3>
                    </div>
                    <div className='flex space-x-6 '>
                      <form action="#" method="GET"  >
                        <label htmlFor="mobile-search" className="sr-only">Search</label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <BiSearch style={{ fontSize: '1.5rem' }} className="text-gray-500" />
                          </div>
                          <input type="text" name="email" id="mobile-search" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  focus:ring-cyan-600 block w-full pl-10 p-2.5" placeholder="Search" onChange={this.handleSearch} required />
                        </div>
                      </form>
                      <button className="flex items-center px-6 py-2 text-sm font-medium text-white capitalize bg-blue-500 rounded-md" onClick={() => this.handleAddCategoryModal()}><MdAdd style={{ fontSize: "1.5rem" }} className="mr-1.5" /> Add Category </button>
                    </div>
                  </div>
                  <div className="pb-2 mt-4 overflow-hidden rounded-lg shadow-md">
                    <div className="max-w-full overflow-x-auto">
                      <div className="inline-block min-w-full ">
                        <div className="overflow-x-auto">
                          <table className="min-w-full border-0 divide-y ">
                            <thead className="bg-gray-200 rounded-t">
                              <tr className="text-sm font-semibold text-left text-gray-500 uppercase">
                                <th className="px-6 py-3 whitespace-nowrap">#</th>
                                <th className="px-6 py-3 whitespace-nowrap">Name</th>
                                <th className="px-6 py-3 whitespace-nowrap">Date/Time</th>
                                <th className="px-6 py-3 whitespace-nowrap">Enable/Disable</th>
                                <th className="px-6 py-3 text-center whitespace-nowrap">Actions</th>
                              </tr>
                            </thead>

                            <tbody>
                              {leadItems && leadItems.length > 0 ?
                                leadItems.map((element, index) => (<React.Fragment key={element.id}>
                                  <tr key={element.id} className="bg-white border-b border-black border-opacity-10 ">
                                    <td className="px-6 py-3 text-sm font-medium text-gray-600 whitespace-nowrap">
                                      {this.state.offset + index + 1}</td>
                                    <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">{element && element.name ? element.name : "-"}</td>
                                    <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">{moment(new Date(parseInt(element.createdAt))).utcOffset("+05:30").format("YYYY-MM-DD HH:mm")}</td>
                                    <td className="px-2 py-3 text-sm text-gray-600 whitespace-nowrap">
                                      <span className="flex justify-center pl-1">
                                        {element.isDisable === false ?
                                          <div class="targetablepx-4 tooltip px-3 py-1 font-medium tracking-wider text-blue-100 bg-red-500 border rounded-md shadow-sm hover:shadow-lg hover:bg-green-400 cursor-pointer" onClick={() => this.updateCategoryStatus(element)}>
                                            <label>Disable</label>
                                          </div>
                                          : <div class="targetablepx-4 tooltip px-3 py-1 font-medium tracking-wider text-blue-100 bg-green-700 border rounded-md shadow-sm hover:shadow-lg hover:bg-green-400 cursor-pointer" onClick={() => this.updateCategoryStatus(element)}>
                                            <label>Enable</label>
                                          </div>}
                                      </span>
                                    </td>
                                    <td className="flex justify-center px-2 py-3 space-x-2 text-center text-gray-600 whitespace-nowrap">
                                      <div className='flex space-x-2'>
                                        <span className="relative">
                                          <div class="targetablepx-4 tooltip p-2 rounded-full font-medium hover:bg-blue-100 cursor-pointer" onClick={() => this.handleUpdateCategoryModal(element)}>
                                            <span className='top-0 left-0 p-6 mx-auto -mt-8 text-sm text-white bg-gray-500 rounded tooltip-text'>Edit</span>
                                            <MdOutlineEdit style={{ fontSize: "1.5rem" }} />
                                          </div>
                                        </span>
                                        <span className="relative">
                                          <div class="targetablepx-4 tooltip p-2 rounded-full font-medium hover:bg-blue-100 cursor-pointer" onClick={() => this.deleteCategory(element)}>
                                            <span className='top-0 left-0 p-6 mx-auto -mt-8 text-sm text-white bg-gray-500 rounded tooltip-text'>Delete</span>
                                            <FaRegTrashAlt style={{ fontSize: "1.5rem" }} />
                                          </div>
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </React.Fragment>))
                                : (<tr className="bg-white bg-opacity-5 " >
                                  <td className="col-span-3 px-6 py-3 text-sm font-medium text-gray-500 whitespace-nowrap">Not Found</td>
                                </tr>)
                              }
                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                    {/* Table Pagination Section */}
                    {
                      isMobile ?
                        <nav className="relative z-0 flex justify-end mt-5 w-76">
                          {
                            leadTotal && leadTotal > 10 ?
                              <ReactPaginate
                                previousLabel={'Prev'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={leadTotal / this.state.size}
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={1}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                pageClassName={'page-cls'}
                                activeClassName={'active'}
                              />
                              : null}
                        </nav> : <nav className="relative z-0 flex justify-end mt-5 w-76">
                          {
                            leadTotal && leadTotal > 10 ?
                              <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={leadTotal / this.state.size}
                                marginPagesDisplayed={3}
                                pageRangeDisplayed={3}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                pageClassName={'page-cls'}
                                activeClassName={'active'}
                              />
                              : null}
                        </nav>
                    }
                  </div>
                </section>
              </div>
            </div>
          </main>
        </div>

        <DialogExample />

        <AddCategoryModal
          handleAddCategoryModalClose={this.handleAddCategoryModalClose}
          addCategoryModal={this.state.addCategoryModal}
          fieldsQuote={this.state.fieldsQuote}
          errorsQuote={this.state.errorsQuote}
          inputAddUserChange={this.inputAddUserChange}
          createCategorySubmit={this.createCategorySubmit}
        />

        <UpdateCategoryModal
          updateCategoryModal={this.state.updateCategoryModal}
          fieldsUserUpdate={this.state.fieldsUserUpdate}
          errorsUpdateQuote={this.state.errorsUpdateQuote}
          inputChangeUpdateUser={this.inputChangeUpdateUser}
          updateCategory={this.updateCategory}
          handleUpdateCategoryModalClose={this.handleUpdateCategoryModalClose}
        />
      </>

    );
  }
}
function mapStateToProps(state) {
  const { users } = state;
  return {
    users
  };
}
export default connect(mapStateToProps)(Category);
